import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ConfirmationService, MessageService, Message, PrimeNGConfig } from 'primeng/api';
import { Router } from '@angular/router';
import { FAZILService, UserService } from '../core/services';
import { MenuService } from '../app.menu.service';
import { AppComponent } from '../app.component';
import { environment } from 'src/environments/environment';
import { User } from '../core';
import { UIService } from '../core/services/ui.service';
import { AppMainComponent } from '../app.main.component';
import { AdministracionService } from '../administracion/administracion.service';
import { DataService } from '../services/data.service';
import { Plan } from '../modelo/Plan';
import { StyleClass } from 'primeng/styleclass';
import { PlanOrganizacion } from '../modelo/PlanOrganizacion';

import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { UsuarioModel } from 'src/app/modelo/usuario.model';
import { RegistroService } from '../registro/registro.service';

export interface ResultData {
    header: string;
    body: string;
    type: string;
}

@Component({
    selector: 'app-landing',
    templateUrl: './app.landing.component.html',
    styleUrls: ['./app.landing.component.scss'],
    animations: [
        trigger('mask-anim', [
            state(
                'void',
                style({
                    opacity: 0
                })
            ),
            state(
                'visible',
                style({
                    opacity: 0.8
                })
            ),
            transition('* => *', animate('250ms cubic-bezier(0, 0, 0.2, 1)'))
        ])
    ]
})
export class AppLandingComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    photo: any;
    planes: Plan[] = [];
    planOrganizacion: PlanOrganizacion = new PlanOrganizacion();
    planSelected: Plan = new Plan();

    //Variables auxiliares
    caracteristicasPlanes: any[];
    mostrarEditor: boolean = false;
    
    mostrarTerminosCondiciones:boolean = false;

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;
    app: AppComponent;
    appMain: AppMainComponent;
    
    planesFactura: Plan[] = [];
    planesFirma: Plan[] = [];
    planesUsuario: Plan[] = [];
    
    //Para tomar los datos de la pantalla
    newUser: UsuarioModel = new UsuarioModel();
    
    mesajeDeCargaInicial: string = this.appConfig.ux.loadingMsg;
    
    constructor(
        public appMainController: AppMainComponent,
        public appController: AppComponent,
        private router: Router,
        private userService: UserService,
        private administracionService: AdministracionService,
        private uiService: UIService,
        private fazilService: FAZILService,
        private registroService: RegistroService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService
    ) {
        this.ui = uiService;
        this.appMain = appMainController;
        this.app = appController;
        this.cargarDataConstructor();
    }

    async cargarDataConstructor() {
        this.breadcrumbService.setItems([
            { label: 'Mejora tu plan ' + this.appConfig.app.name, routerLink: ['planes'] }
        ]);
        
        this.planesFactura = await this.registroService.getPlanesPorTipoPlanData(this.appConfig.properties.tiposPlan.facturacion);
        this.planesFirma = await this.registroService.getPlanesPorTipoPlanData(this.appConfig.properties.tiposPlan.firma);
    }

    ngOnInit() {
        this.userService.currentUser.subscribe((userData) => {
            this.currentUser = userData;
            let imagen = this.ui.sanitize(this.currentUser.image);
            this.photo = imagen ? imagen : '/assets/layout/icons/user.png';
            this.cargarDataInit();
        });
    }

    async cargarDataInit() {
        this.planes = await this.administracionService.getPlanesData();
    }

    resetVariables(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this.mostrarResultData = false;
        this.planSelected = new Plan();
        this.planOrganizacion = new PlanOrganizacion();
    }

    lanzarEditorPlan(plan) {
        this.resetVariables();
        this.planSelected = plan;
        this.planOrganizacion.maximoComprobantes = this.planSelected.maximoComprobantes;
        this.mostrarEditor = true;
    }

    formPrincipalCompleto() {
        let valid: boolean = true;
        if (this.planOrganizacion.maximoComprobantes > this.planSelected.maximoComprobantes || this.planOrganizacion.maximoComprobantes < 0) {
            this.ui.mostrarMensaje("warn", `El número máximo de comprobantes debe estar entre 0 a ${this.planSelected.maximoComprobantes}.`);
            valid = false;
        }
        return valid;
    }

    enviarPlanSeleccionado() {
        this.ui.limpiarMessages();
        if (!this.formPrincipalCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            this.procesando = true;
            //Establecer valores UX
            this.planOrganizacion.planId = this.planSelected.id;
            this.planOrganizacion.precio = this.planSelected.precio;
            this.planOrganizacion.planName = this.planSelected.name;
            this.planOrganizacion.description = this.planSelected.description;
            this.planOrganizacion.subjectCustomer = null;
            //Guardar planOrganizacion en persistencia
            this.administracionService.enviarPlanOrganizacion(this.planOrganizacion).subscribe(
                async (data) => {
                    this.mostrarEditor = false;


                    let msg = `¡Plan listo para facturar!. Enhorabuena se ha registrado el pla ${data['planName']} con ${data['maximoComprobantes']} facturas disponibles para ${this.currentUser.initials}`
                    this.resultData = this.ui.buildResultFromData(msg, this.appConfig.ux.messagesType.success);
                    this.resultDataButtons = [];
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonInvoicer);
                    this.procesando = false;
                    this.mostrarResultData = true;
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    /**
    ** Métodos de formulario
    **/
    verificarMaximoComprobantes(event) {
        this.ui.limpiarMessages();
        if (event && (this.planOrganizacion.maximoComprobantes > this.planSelected.maximoComprobantes || this.planOrganizacion.maximoComprobantes < 0)) {
            this.ui.mostrarMensaje("warn", `El número máximo de comprobantes debe estar entre 0 a ${this.planSelected.maximoComprobantes}.`);
            this.planOrganizacion.maximoComprobantes = this.planSelected.maximoComprobantes;
        }
    }

    ejecutarAccion(event, accion: string, item: any) {
        this.ui.limpiarMessages();
        if (accion == 'result-close') {
            this.mostrarResultData = false;
        } else if (accion == 'facturar') {
            this.fazilService.irAFactura();
        }
    }

    //Gestión de planes
    agregarPlanSeleccionado(event, plan: Plan) {
        this.ui.limpiarMessages();
        let existePlanPorTipo = this.planesUsuario.find((item) => item.tipoPlan == plan.tipoPlan);

        if (existePlanPorTipo) {
            const indexOfObject = this.planesUsuario.findIndex((item) => item?.tipoPlan == plan?.tipoPlan);
            this.planesUsuario[indexOfObject] = plan;
            this.messageService.add({ key: 'bc', severity: 'info', summary: '¡Bien!', detail: `${plan.name} agregado.` });
        } else {
            this.planesUsuario.push(plan);
            this.messageService.add({ key: 'bc', severity: 'info', summary: '¡Bien!', detail: `${plan.name} agregado.` });
        }

        switch (plan.tipoPlan) {
            case this.appConfig.properties.tiposPlan.facturacion:
                this.newUser.planId = plan.id;
                break;
            case this.appConfig.properties.tiposPlan.firma:
                this.newUser.planIdTipoFirma = plan.id;
                break;
            default:
                break;
        }

    }
    
    abrirTerminosCondiciones() {
        this.mostrarTerminosCondiciones = true;
    }
    
    formSubjectCompleto() {
        return true;
    }

    async mejorarPlan() {
        this.ui.limpiarMessages();
        if (!(this.planesUsuario && this.planesUsuario.length > 0)) {
            this.ui.mostrarMensaje("error", `${this.newUser.firstname}, elige el plan que necesitas..`);
            return;
        }
        if (!this.formSubjectCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
           
            //this.newUser.planId = this.planSelected.id;
            this.newUser.uuid = this.currentUser.uuid;
            this.newUser.aceptaTerminosCondiciones = this.newUser.planAceptaTerminosCondiciones;
            //Corregir ausencia de plan de factura, si solo se eligió plan de firma
            if (!this.newUser.planId && this.newUser.planIdTipoFirma) {
                this.newUser.planId = this.newUser.planIdTipoFirma; //Hacer el plan de firma como principal
                this.newUser.planIdTipoFirma = null; //No hay otro plan seleccionado
            }
            this.newUser.sitioReferencia = ''; //sitio referencia

            //Guardar planOperacion en persistencia
            this.registroService.comprarPlan(this.newUser).subscribe(
                async (data) => {
                    await this.esperarParaRedirigir();
                    this.router.navigate(['']);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }
    
    async esperarParaRedirigir() {
        this.cargandoDataInit = true;
        this.mesajeDeCargaInicial = "¡Muy bien! Tu petición ha sido enviado a un asesor FacturaFácil Ecuador, pronto nos contacteremos contigo."
        setTimeout(() => {
            this.cargandoDataInit = false;
        }, 7000);
    }
}
